"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "agent-selector" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = { class: "agent-list" };
const _hoisted_4 = ["disabled", "onBlur", "onKeydown"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const vue_3 = require("vue");
const KebabMenuIcon_vue_1 = __importDefault(require("../../../vue/icons/KebabMenuIcon.vue"));
const DeleteIcon_vue_1 = __importDefault(require("../../../vue/icons/DeleteIcon.vue"));
const EditIcon_vue_1 = __importDefault(require("../../../vue/icons/EditIcon.vue"));
const provider_1 = require("../../../provider/provider");
const autoAIAgentRequest_1 = require("../../../requests/autoAIAgentRequest");
const summary_lib_1 = require("../../../js/summary_lib");
const errors_1 = __importDefault(require("../../../js/errors"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIAgentSelector',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.autoAIAgentViewModelInjectKey);
        const presenter = (0, vue_3.inject)(provider_1.autoAIAgentPresenterInjectKey);
        const agents = (0, vue_3.ref)(viewModel?.value.agents ?? []);
        const isLoading = (0, vue_3.ref)(false);
        const openMenuAgentId = (0, vue_3.ref)();
        const editingAgentId = (0, vue_3.ref)();
        const editingAgentName = (0, vue_3.ref)('');
        const savingAgentId = (0, vue_3.ref)();
        const isComposingAgentName = (0, vue_3.ref)(false);
        const agentNameInput = (0, vue_3.ref)();
        let agentsVersion = 0;
        function setAgentNameInput(element) {
            agentNameInput.value = element instanceof HTMLInputElement ? element : undefined;
        }
        function getRequestContext() {
            const vm = viewModel?.value;
            if (!vm) {
                return;
            }
            return {
                branchId: vm.branchId,
                userId: vm.userId,
            };
        }
        function openAgent(agent) {
            presenter?.selectAgent(agent);
        }
        function toggleAgentMenu(agentId) {
            openMenuAgentId.value = openMenuAgentId.value === agentId ? undefined : agentId;
        }
        function closeAgentMenu() {
            openMenuAgentId.value = undefined;
        }
        function editAgentName(agent) {
            closeAgentMenu();
            editingAgentId.value = agent.ID;
            editingAgentName.value = agent.Name;
            (0, vue_3.nextTick)(() => {
                agentNameInput.value?.focus();
                agentNameInput.value?.select();
            });
        }
        function cancelAgentNameEdit() {
            editingAgentId.value = undefined;
            editingAgentName.value = '';
        }
        async function saveAgentName(agent) {
            if (editingAgentId.value !== agent.ID || savingAgentId.value === agent.ID) {
                return;
            }
            const name = editingAgentName.value.trim();
            if (!name || name === agent.Name) {
                cancelAgentNameEdit();
                return;
            }
            const context = getRequestContext();
            if (!context || !presenter) {
                (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.UPDATE);
                cancelAgentNameEdit();
                return;
            }
            savingAgentId.value = agent.ID;
            try {
                await (0, autoAIAgentRequest_1.updateAutoAIAgentNameRequest)(context.branchId, context.userId, agent.ID, name);
                agentsVersion++;
                presenter.updateAgentName(agent.ID, name);
                agents.value = viewModel?.value.agents ?? agents.value;
                cancelAgentNameEdit();
            }
            catch {
                (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.UPDATE);
            }
            finally {
                savingAgentId.value = undefined;
            }
        }
        function saveAgentNameOnEnter(agent) {
            if (isComposingAgentName.value) {
                return;
            }
            saveAgentName(agent);
        }
        async function deleteAgent(agent) {
            const context = getRequestContext();
            if (!context) {
                (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.DELETE);
                return;
            }
            try {
                await (0, autoAIAgentRequest_1.deleteAutoAIAgentRequest)(context.branchId, context.userId, agent.ID);
                agentsVersion++;
                agents.value = agents.value.filter(({ ID }) => ID !== agent.ID);
                presenter?.setAgents(agents.value);
            }
            catch {
                (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.DELETE);
            }
        }
        function confirmDeleteAgent(agent) {
            closeAgentMenu();
            const agentName = agent.Name || 'シフトエージェント';
            (0, summary_lib_1.openConfirmModal)(`${agentName}を削除しますか？`, () => deleteAgent(agent));
        }
        async function loadAgents() {
            const vm = viewModel?.value;
            if (vm?.hasLoadedAgents) {
                agents.value = vm.agents;
                return;
            }
            const context = getRequestContext();
            if (!context) {
                (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.LOAD);
                return;
            }
            const requestVersion = agentsVersion;
            try {
                const loadedAgents = await (0, autoAIAgentRequest_1.getAutoAIAgentsRequest)(context.branchId, context.userId);
                if (requestVersion !== agentsVersion) {
                    return;
                }
                agents.value = loadedAgents;
                presenter?.setAgents(agents.value);
            }
            catch {
                if (requestVersion === agentsVersion) {
                    (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.LOAD);
                }
            }
        }
        async function createAgent() {
            const context = getRequestContext();
            if (!context || !presenter || isLoading.value) {
                return;
            }
            isLoading.value = true;
            try {
                const newAgent = await (0, autoAIAgentRequest_1.createAutoAIAgentRequest)(context.branchId, context.userId, presenter.getNextAgentName());
                agentsVersion++;
                agents.value = [newAgent, ...agents.value];
                presenter.addAgent(newAgent);
                presenter.selectAgent(newAgent);
            }
            catch {
                (0, summary_lib_1.openAlertModal)(errors_1.default.SHIFTAGENT.CREATE);
                isLoading.value = false;
            }
        }
        (0, vue_3.onMounted)(() => {
            loadAgents();
            document.addEventListener('click', closeAgentMenu);
        });
        (0, vue_3.onBeforeUnmount)(() => {
            document.removeEventListener('click', closeAgentMenu);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("button", {
                    class: "shift-agent-btn create-btn",
                    type: "button",
                    disabled: isLoading.value,
                    onClick: createAgent
                }, " 新しいシフトエージェントを作成 ", 8 /* PROPS */, _hoisted_2),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(agents.value, (agent) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: agent.ID,
                            class: (0, vue_2.normalizeClass)(["agent-button-wrapper", { 'menu-open': openMenuAgentId.value === agent.ID }])
                        }, [
                            (editingAgentId.value === agent.ID)
                                ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", {
                                    key: 0,
                                    ref_for: true,
                                    ref: setAgentNameInput,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((editingAgentName).value = $event)),
                                    class: "agent-name-input",
                                    type: "text",
                                    disabled: savingAgentId.value === agent.ID,
                                    onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(() => { }, ["stop"])),
                                    onBlur: ($event) => (saveAgentName(agent)),
                                    onKeydown: [
                                        (0, vue_2.withKeys)((0, vue_2.withModifiers)(($event) => (saveAgentNameOnEnter(agent)), ["prevent"]), ["enter"]),
                                        (0, vue_2.withKeys)((0, vue_2.withModifiers)(cancelAgentNameEdit, ["prevent"]), ["esc"])
                                    ],
                                    onCompositionstart: _cache[2] || (_cache[2] = ($event) => (isComposingAgentName.value = true)),
                                    onCompositionend: _cache[3] || (_cache[3] = ($event) => (isComposingAgentName.value = false))
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4)), [
                                    [vue_2.vModelText, editingAgentName.value]
                                ])
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 1,
                                    class: "shift-agent-btn",
                                    type: "button",
                                    onClick: ($event) => (openAgent(agent))
                                }, (0, vue_2.toDisplayString)(agent.Name || `シフトエージェント`), 9 /* TEXT, PROPS */, _hoisted_5)),
                            (0, vue_2.createElementVNode)("button", {
                                class: "agent-menu-btn oplus-icon",
                                type: "button",
                                onClick: (0, vue_2.withModifiers)(($event) => (toggleAgentMenu(agent.ID)), ["stop"])
                            }, [
                                (0, vue_2.createVNode)(KebabMenuIcon_vue_1.default)
                            ], 8 /* PROPS */, _hoisted_6),
                            (openMenuAgentId.value === agent.ID)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 2,
                                    class: "agent-menu-popup flex-center",
                                    onClick: _cache[4] || (_cache[4] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                                }, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "delete-agent-btn oplus-icon",
                                        type: "button",
                                        onClick: ($event) => (confirmDeleteAgent(agent))
                                    }, [
                                        (0, vue_2.createVNode)(DeleteIcon_vue_1.default)
                                    ], 8 /* PROPS */, _hoisted_7),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "edit-agent-btn oplus-icon",
                                        type: "button",
                                        onClick: ($event) => (editAgentName(agent))
                                    }, [
                                        (0, vue_2.createVNode)(EditIcon_vue_1.default)
                                    ], 8 /* PROPS */, _hoisted_8)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ], 2 /* CLASS */));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
